export var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus[NotificationStatus["UNREAD"] = 100] = "UNREAD";
    NotificationStatus[NotificationStatus["READ"] = 110] = "READ";
})(NotificationStatus || (NotificationStatus = {}));
//# sourceMappingURL=notification-status.enum.js.map